export const RadiusID = {
  Small: "small-radius-collection",
  Medium: "medium-radius-collection",
  Large: "large-radius-collection",
  Custom: "custom-radius-collection",
};
